import React from 'react';
import { Button } from '@attain-sre/attain-design-system';
import {
  OTS_SGM_MNG_CLEAR_SELECTION,
  OTS_SGM_MNG_DELETE_SELECTED,
  OTS_SGM_MNG_SEGMENTS_SELECTED,
} from '../../../../content';
import { Trash, X } from '@phosphor-icons/react';
import * as Styled from './index.styles';

export type SegmentSelectionToolbarProps = {
  /** When false, the toolbar is not rendered (default hidden until selection exists). */
  visible: boolean;
  selectedCount: number;
  selectionDisabled: boolean;
  onDeleteClick: () => void;
  onClear: () => void;
};

/**
 * Bulk selection actions for Segment Manager (shown only when at least one row is selected).
 */
const SegmentSelectionToolbar: React.FC<SegmentSelectionToolbarProps> = ({
  visible,
  selectedCount,
  selectionDisabled,
  onDeleteClick,
  onClear,
}) => {
  if (!visible || selectedCount < 1) {
    return null;
  }

  return (
    <Styled.SelectionActionBar>
      <Styled.SelectionActionBarLeft>
        <Styled.SelectionCountText>
          {selectedCount} {OTS_SGM_MNG_SEGMENTS_SELECTED}
        </Styled.SelectionCountText>
      </Styled.SelectionActionBarLeft>
      <Styled.SelectionActionsRight>
        <Styled.ToolbarDeleteButton
          color="error"
          variant="contained"
          disabled={selectionDisabled}
          onClick={onDeleteClick}
        >
          <span
            className="toolbar-delete-inner"
            style={{ display: 'inline-flex', alignItems: 'center', gap: 8 }}
          >
            <Trash size={18} weight="bold" color="#ffffff" aria-hidden />
            {OTS_SGM_MNG_DELETE_SELECTED}
          </span>
        </Styled.ToolbarDeleteButton>
        <Button
          color="primary"
          variant="outlined"
          disabled={selectionDisabled}
          onClick={onClear}
        >
          <span
            style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}
          >
            <X size={18} aria-hidden />
            {OTS_SGM_MNG_CLEAR_SELECTION}
          </span>
        </Button>
      </Styled.SelectionActionsRight>
    </Styled.SelectionActionBar>
  );
};

export default SegmentSelectionToolbar;
